module.exports = __webpack_public_path__ + "img/banner_product.31009854.jpg";